
// ROUTES
require('modules/relator/routes/relator');

// CONTROLLERS
require('modules/relator/controllers/relator');
require('modules/relator/controllers/list');
require('modules/relator/controllers/create');
require('modules/relator/controllers/edit');

// SERVICES
require('modules/relator/services/relator');
require('modules/relator/services/list');
require('modules/relator/services/create');
require('modules/relator/services/edit');
require('modules/relator/services/delete');


angular.module('unica_relator', [

	// ROUTES
	'unica_relator.relator_routes',

	// CONTROLLERS
	'unica_relator.relator_controllers',

	// SERVICES
	'unica_relator.relator_services'

]);